"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelectControl = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("../../hooks");
var _MultiSelectControl = require("./MultiSelectControl.styled");
var MultiSelectControl = exports.MultiSelectControl = function MultiSelectControl(_ref) {
  var showLabel = _ref.showLabel,
    theme = _ref.theme,
    onTakeStagedLive = _ref.onTakeStagedLive,
    onClearStaged = _ref.onClearStaged;
  var pageWidth = (0, _hooks.useCurrentWidth)();
  var updateLiveText = 'Update stage';
  var clearSelectedText = 'Clear selections';
  return /*#__PURE__*/_react["default"].createElement(_MultiSelectControl.StyledSection, null, showLabel && /*#__PURE__*/_react["default"].createElement(_MultiSelectControl.StyledText, {
    theme: theme
  }, "MULTISELECT UPDATES:"), /*#__PURE__*/_react["default"].createElement(_MultiSelectControl.StyledButtonWrapper, {
    pageWidth: pageWidth
  }, /*#__PURE__*/_react["default"].createElement(_MultiSelectControl.UpdateButton, {
    theme: theme,
    onClick: onTakeStagedLive,
    "data-testid": "update-program-layout"
  }, updateLiveText), /*#__PURE__*/_react["default"].createElement(_MultiSelectControl.ClearButton, {
    theme: theme,
    onClick: onClearStaged
  }, clearSelectedText)));
};
MultiSelectControl.defaultProps = {
  showLabel: true,
  theme: 'dark'
};
MultiSelectControl.propTypes = {
  theme: _propTypes["default"].string,
  showLabel: _propTypes["default"].bool,
  onTakeStagedLive: _propTypes["default"].func.isRequired,
  onClearStaged: _propTypes["default"].func.isRequired
};